import React from'react';/**
 * Used to store any temporary state needed for the signup or campaign creation wizard in UP.
 */export var UpWizardContext=React.createContext([]);